import React from 'react';

import PropTypes from 'prop-types';

import {
    OUTLINE_RADIUS,
    POINT_RADIUS,
} from '../constants';
import {
    drawCurve,
    drawLine,
} from '../utils';

import styles from './LineChart.scss';

const propTypes = {
    data: PropTypes.object.isRequired,
    onHover: PropTypes.func,
    type: PropTypes.oneOf(['curve', 'line']),
};
const defaultProps = {
    type: 'curve',
    onHover() {},
};

function LineChart(props) {
    const {
        data,
        onHover,
        type,
    } = props;

    const drawFn = type === 'curve'
        ? drawCurve
        : drawLine;

    function _drawPath() {
        const d = Object.values(data).reduce((str, point, index, arr) => {
            const {
                xCoord: x,
                yCoord: y,
            } = point;

            return index === 0
                ? `M ${x},${y}`
                : `${str} ${drawFn(point, index, arr)}`;
        }, '');

        return (
            <path
                className={styles.line}
                d={d}
            />
        );
    }

    function _drawPoints() {
        return Object.values(data).map((point) => {
            const {
                xVal,
                xCoord: x,
                yCoord: y,
                yVal,
            } = point;

            const tooltip = {
                xPos: x,
                xVal,
                yPos: y,
                yVal,
            };

            return (
                <g
                    className={styles.pointGroup}
                    key={`${x}-${y}`}
                    onMouseOut={() => onHover(false, {})}
                    onMouseOver={() => onHover(true, tooltip)}
                    onTouchEnd={() => onHover(false, {})}
                    onTouchStart={() => onHover(true, tooltip)}
                >
                    <circle
                        className={styles.point}
                        cx={x}
                        cy={y}
                        r={POINT_RADIUS}
                    />
                    <circle
                        className={styles.outline}
                        cx={x}
                        cy={y}
                        r={OUTLINE_RADIUS}
                    />
                </g>
            );
        });
    }

    return (
        <>
            {_drawPath()}
            {_drawPoints()}
        </>
    );
}

LineChart.propTypes = propTypes;
LineChart.defaultProps = defaultProps;

export default LineChart;
